import styled from 'styled-components/macro'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'
import { typography } from 'styles/typography'

export const Footer = styled.footer`
  --gap: 8%;
  position: relative;

  ${typography.body}
  padding-block: var(--spacing-lg);
  color: ${theme.colors.background};
  border-bottom: 1rem solid ${theme.colors.primary};
  background-color: ${theme.colors.theme};
`

export const Top = styled.div`
  ${mq.large} {
    display: flex;
    gap: var(--gap);
    align-items: start;
  }
`

export const Head = styled.div`
  ${mq.large} {
    width: 28%;
  }
`

export const Title = styled.h2`
  ${typography.h1}
  margin: 0;

  ${mq.large} {
    width: min-content;
  }
`

export const Subtitle = styled.p`
  ${typography.strong}
`

export const Credits = styled.dl`
  margin: var(--spacing-md) 0 0;

  ${mq.medium} {
    columns: 2;
    column-gap: var(--gap);
  }

  ${mq.large} {
    margin: 0;
    column-gap: calc(var(--gap) * 1.5);
  }
`

export const Socials = styled.ul`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
  list-style: none;
  font-size: 3.4rem;

  li {
    display: block;
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${theme.colors.theme};
    width: 3.8rem;
    aspect-ratio: 1;
    border-radius: 0.34em;
    transition: border-radius 0.3s;
    background-color: white;
  }

  a:hover,
  a:focus-visible {
    border-radius: 50%;
  }
`

export const CreditsItem = styled.div`
  margin-bottom: 0.8em;
  break-inside: avoid-column;
`

export const Role = styled.dt`
  ${typography.strong}
  text-wrap: balance;
`

export const Names = styled.dd`
  margin: 0;
  font-weight: 300;
`

export const Foot = styled.div`
  position: relative;
  padding-top: var(--spacing-lg);
  margin-top: var(--spacing-lg);

  p:first-child {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }

  ${mq.medium} {
    display: flex;
    gap: calc(0.66667 * var(--gap));

    p {
      margin: 0;
    }
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    opacity: 0.25;
    border-top: 1px solid currentColor;
  }
`

export const NameList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`
